import "moment-timezone";

import React, { Component, useEffect, useRef, useState } from "react";

import Moment from "react-moment";
import { SpinnerComponent } from "react-element-spinner";

const CURRENT = "current";
const FINANCIAL = "financial";

const CURRENTFILTERPOS = 0;
const FINANCIALFILTERPOS = 1;

//const FINANCIALREPORTFILTER = Object.freeze({
//  All: 0,
//  Yearly: 1,
//  SemiAnnual: 2,
//  Quarterly: 3,
//});

class ReportListBlockView extends Component {
  constructor(props) {
    super(props);

    //const FINANCIALSUBFILTERS = [
    //  {
    //    text: episerver_financial_filter_all,
    //    value: FINANCIALREPORTFILTER.All,
    //  }, // "All"
    //  {
    //    text: episerver_financial_filter_yearly,
    //    value: FINANCIALREPORTFILTER.Yearly,
    //  }, // "Yearly"
    //  {
    //    text: episerver_financial_filter_semiAnnual,
    //    value: FINANCIALREPORTFILTER.SemiAnnual,
    //  }, // "SemiAnnual"
    //  {
    //    text: episerver_financial_filter_quarterly,
    //    value: FINANCIALREPORTFILTER.Quarterly,
    //  }, // "Quarterly"
    //];

    this.state = {
      selectedReport: CURRENT,
      selectedSubFilter: [
        new Date().getFullYear(),
        new Date().getFullYear(),
        //FINANCIALSUBFILTERS[3].value,
        "",
      ],
      selectedSubFilterText: [
        new Date().getFullYear(),
        new Date().getFullYear(),
        //FINANCIALSUBFILTERS[3].text,
        "",
      ],
      currentReports: [],
      financialReports: [],
      isLoading: false,
      //financialSubFilters: FINANCIALSUBFILTERS,
    };
  }

  componentDidMount() {
    this.fetchDisplayData(CURRENT);
    this.fetchDisplayData(FINANCIAL);
  }

  fetchDisplayData(selected) {
    switch (selected) {
      case CURRENT:
        if (this.state.selectedSubFilter[CURRENTFILTERPOS] !== "")
          this.fetchCurrentReports(
            episerver_cision_local,
            this.state.selectedSubFilter[CURRENTFILTERPOS],
            "",
            ""
          );
        break;
      case FINANCIAL:
        if (this.state.selectedSubFilter[FINANCIALFILTERPOS] !== "") {
          this.featchFinancialReports(
            episerver_cision_local,
            "5",
            this.state.selectedSubFilter[FINANCIALFILTERPOS],
            ""
          );
        }
        break;
    }
  }

  featchFinancialReports(LanguageCode, filterKey, year, pageSize) {
    this.setState({ isLoading: true }, () => {
      this.fetchData(`${episerver_FinancialReportsApiUrl}`, {
        LanguageCode: LanguageCode,
        FilterKey: filterKey,
        Year: year,
        PageSize: pageSize,
      }).then((reports) => {
        this.setState({ financialReports: reports, isLoading: false });
      });
    });
  }

  fetchCurrentReports(LanguageCode, filterKey, year, pageSize) {
    this.setState({ isLoading: true }, () => {
      this.fetchData(`${episerver_CurrentReportsApiUrl}`, {
        LanguageCode: LanguageCode,
        FilterKey: filterKey,
        Year: year,
        PageSize: pageSize,
      }).then((reports) => {
        this.setState({ currentReports: reports, isLoading: false });
      });
    });
  }

  fetchData(url, body) {
    const fetchSettings = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };
    return fetch(url, fetchSettings).then((res) => res.json());
  }

  handleTopLevelFilterChange(selected) {
    this.setState({ selectedReport: selected });
  }

  handleSubLevelFilterChange(filterValue) {
    var selSubFilter = this.state.selectedSubFilter;

    //selSubFilter[FINANCIALFILTERPOS] = filterValue;
    //selSubFilter[CURRENTFILTERPOS] = filterValue;
    
    //this.setState({ selectedSubFilter: selSubFilter });
    this.fetchCurrentReports(episerver_cision_local, filterValue, "", "");
    this.featchFinancialReports(episerver_cision_local, 5, filterValue, "");

    //switch (this.state.selectedReport) {
    //  case CURRENT:
    //    selSubFilter[CURRENTFILTERPOS] = filterValue;
    //    this.setState({ selectedSubFilter: selSubFilter });
    //    this.fetchCurrentReports(episerver_cision_local, filterValue, "", "");
    //    break;
    //  case FINANCIAL:
    //    selSubFilter[FINANCIALFILTERPOS] = filterValue;
    //    this.featchFinancialReports(episerver_cision_local, 0, filterValue, "");
    //    break;
    //  default:
    //    break;
    //}
  }

  reportSelector() {
    return (
      <div className="container no-padding js-report-list-block__filter_container">
        <div className="row">
          <div
            onClick={() => this.handleTopLevelFilterChange(CURRENT)}
            key={`level1-filter-control-1`}
            role="button"
            tabIndex="0"
            className={
              "col-sm js-report-list-block__filter-tab " +
              (this.state.selectedReport === CURRENT
                ? "js-report-list-block__active-filter-tab"
                : "")
            }
          >
            {episerver_current_tab_text}
          </div>
          <div
            onClick={() => this.handleTopLevelFilterChange(FINANCIAL)}
            key={`level1-filter-control-2`}
            role="button"
            tabIndex="0"
            className={
              "col-sm js-report-list-block__filter-tab " +
              (this.state.selectedReport === FINANCIAL
                ? "js-report-list-block__active-filter-tab"
                : "")
            }
          >
            {episerver_financial_tab_text}
          </div>
        </div>
      </div>
    );
  }

  reportList() {
    var reportsToDisplay = [];
    var itemRenderer = this.reportItem;
    switch (this.state.selectedReport) {
      case CURRENT:
        reportsToDisplay = this.state.currentReports;
        break;
      case FINANCIAL:
        reportsToDisplay = this.state.financialReports;
        break;
    }
    return (
      <div className="js-report-list-block__container container no-padding">
        {this.reportRows(reportsToDisplay, itemRenderer)}
      </div>
    );
  }

  reportRows(reportsToDisplay, itemRenderer) {
    var output = [],
      itemTmp = null;
    for (let index = 0; index < reportsToDisplay.length; index++) {
      if ((index + 1) % 2 == 0) {
        output.push(
          this.reportRow(itemTmp, reportsToDisplay[index], index, itemRenderer)
        );
        itemTmp = null;
      } else {
        itemTmp = reportsToDisplay[index];
      }
    }
    if (itemTmp)
      output.push(
        this.reportRow(itemTmp, null, reportsToDisplay.length, itemRenderer)
      );
    return output;
  }

  reportRow(item1, item2, index, itemRenderer) {
    return (
      <div className="container no-padding" key={index}>
        <div className="row">
          {itemRenderer(item1)}
          {item2 ? itemRenderer(item2) : null}
        </div>
      </div>
    );
  }

  reportItem(item) {
    return (
      <div className="col-sm-6 no-padding itemWidth">
        <div className="js-report-list-block__item">
          <div className="filedownloadblock__grid-item">
            <div className="filedownloadblock__image"></div>
            <button className="filedownloadblock__button" type="button">
              <div className="filedownloadblock__content">
                <div className="download-block-text date">
                  <Moment
                    className="date_text"
                    locale={episerver_local}
                    format="DD MMMM, yyyy"
                  >
                    {item.PublishDateUtc}
                  </Moment>
                </div>
                <div className="download-block-text metadata">
                  {item.Files && item.Files.length > 0 ? (
                    <a
                      href={item.Files[0].Url}
                      target={episerver_OpenAllReportsInNewTab ?? "_blank"}
                    >
                      {item.Title}
                    </a>
                  ) : (
                    <p>{item.Title}</p>
                  )}
                </div>
              </div>
              <div className="filedownloadblock__icon">
                {item.Files && item.Files.length > 0 ? (
                  <a
                    href={item.Files[0].Url}
                    target={episerver_OpenAllReportsInNewTab ?? "_blank"}
                  >
                    <img src="/Static/icons/download.svg" />
                  </a>
                ) : (
                  <img src="/Static/icons/download.svg" />
                )}
              </div>
            </button>
          </div>
        </div>
      </div>
    );
  }

  setSubFilterSelectedText(text) {
    var selSubFilterText = this.state.selectedSubFilterText;
    selSubFilterText[0] = text;
    //switch (this.state.selectedReport) {
    //  case CURRENT:
    //    selSubFilterText[0] = text;
    //    break;
    //  case FINANCIAL:
    //    selSubFilterText[0] = text;
    //    break;
    //  default:
    //    break;
    //}
    this.setState({ selectedSubFilterText: selSubFilterText });
  }

  getSubFilterText() {
    return this.state.selectedSubFilterText[0];
    //switch (this.state.selectedReport) {
    //  case CURRENT:
    //    return this.state.selectedSubFilterText[0];
    //    break;
    //  case FINANCIAL:
    //    return this.state.selectedSubFilterText[0];
    //    break;
    //  default:
    //    break;
    //}
  }

  render() {
    return (
      <>
        <div className="pagecomponent--70 js-report-list-block__view">
          {this.reportSelector()}
          <ReportSubSelector
            handleSelect={(selected) => {
              this.handleSubLevelFilterChange(selected);
            }}
            selectedFilterText={() => this.getSubFilterText()}
            setSelectedText={(text) => this.setSubFilterSelectedText(text)}
            subSelectorType={this.state.selectedReport}
            isLoading={this.state.isLoading}
            //financialSubFilter={this.state.financialSubFilters}
          />
          {this.reportList()}
        </div>
      </>
    );
  }
}

function useOutsideAlerter(ref, callback) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

function ReportSubSelector(props) {
    const [displayDropdown, setDisplayDropdown] = useState(false);
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef, () => setDisplayDropdown(false));

    var subSelections = null;

    var CurrentSubSelects = () => {
    var currentYear = new Date().getFullYear();
    var selections = [];
    for (let index = 0; index <= 10; index++) {
      selections.push(
        <div
          key={index}
          onClick={(e) => {
            props.setSelectedText("" + (currentYear - index));
            props.handleSelect(currentYear - index);
            setDisplayDropdown(false);
          }}
        >
          {currentYear - index}
        </div>
      );
    }
    return <>{selections}</>;
  };

  //var FinancialSubSelects = () => {
  //  return (
  //    <>
  //      {props.financialSubFilter.map((item) => (
  //        <div
  //          key={item.value}
  //          value={item.value}
  //          onClick={(e) => {
  //            props.setSelectedText(item.text);
  //            props.handleSelect(item.value);
  //            setDisplayDropdown(false);
  //          }}
  //        >
  //          {item.text}
  //        </div>
  //      ))}
  //    </>
  //  );
  //};

  switch (props.subSelectorType) {
    case CURRENT:
      subSelections = CurrentSubSelects();
      break;
    case FINANCIAL:
      subSelections = CurrentSubSelects();
      break;
    default:
      break;
  }

  if (subSelections != null) {
    return (
      <>
        <div className="container no-padding js-report-list-block__filter_container">
          <div className="row no-padding justify-content-center">
            <div
              className="col-sm-4 no-padding filter-selector"
              ref={wrapperRef}
            >
              <div
                className="filter_text"
                onClick={() =>
                  displayDropdown
                    ? setDisplayDropdown(false)
                    : setDisplayDropdown(true)
                }
              >
                <SpinnerComponent
                  loading={props.isLoading}
                  spinnerType="circle-dots"
                  position="centered"
                  backgroundColor="#dddddd"
                />
                {props.selectedFilterText()}
              </div>
              {displayDropdown ? (
                <div className="container no-padding">
                  <div className="row no-padding justify-content-center">
                    <div className="col no-padding filter_content">
                      {subSelections}
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return null;
  }
}

export default ReportListBlockView;
